module.exports = __webpack_public_path__ + "img/2015047.54f6afd9.svg";